export const es = {
    REQUIRED_ACTION_KeepCapturing: 'Sigue capturando.',
    REQUIRED_ACTION_PauseCapturing: 'Pausar la captura.',
    REQUIRED_ACTION_Close: 'Cerca.',
    REQUIRED_ACTION_Error: 'Error',
    REQUIRED_ACTION_AGREE: 'De acuerdo',
    REQUIRED_ACTION_DISAGREE: 'En desacuerdo',
    LIVENESS_ACTION_Smile: 'Sonríe',
    LIVENESS_ACTION_Frown: 'Fruncir el ceño',
    'LIVENESS_ACTION_Tilt Left': 'Mira a la izquierda.',
    'LIVENESS_ACTION_Tilt Right': 'Mira a la derecha.',
    'LIVENESS_ACTION_Tilt Up': 'Mirar hacia arriba',
    'LIVENESS_ACTION_Tilt Down': 'Mira abajo.',
    'LIVENESS_ACTION_Look Straight': 'Mira hacia adelante.',
    'LIVENESS_ACTION_No Action': 'Sin acción',
    LIVENESS_ACTION_PROCESSING_LIVENESS: 'Tratamiento de la lentitud',
    'LIVENESS_RESULT_Thank you!.Failed': 'Fracasado',
    'LIVENESS_RESULT_Thank you!.Passed': 'Aprobado',
    'LIVENESS_RESULT_Thank you!.ActionTimedOut': 'Acción agotada.',
    'LIVENESS_RESULT_Thank you!.Interrupted': 'Interrumpido',
    'LIVENESS_RESULT_Thank you!.Undefined': 'Indefinido',
    LIVENESS_ACTION_LOOK_STRAIGHT_TITLE: 'Mirar hacia adelante',
    LIVENESS_ACTION_LOOK_STRAIGHT_TEXT:
        'Mantener los ojos en la pantalla en todo momento',
    LIVENESS_ACTION_LOOK_LEFT_TITLE:
        'Girar la cabeza ligeramente hacia la izquierda',
    LIVENESS_ACTION_LOOK_LEFT_TEXT:
        'Mantener los ojos en la pantalla en todo momento',
    LIVENESS_ACTION_LOOK_RIGHT_TITLE:
        'Girar la cabeza ligeramente hacia la derecha',
    LIVENESS_ACTION_LOOK_RIGHT_TEXT:
        'Mantener los ojos en la pantalla en todo momento',
    LIVENESS_ACTION_LOOK_UP_TITLE: 'Girar la cabeza ligeramente hacia arriba',
    LIVENESS_ACTION_LOOK_UP_TEXT:
        'Mantener los ojos en la pantalla en todo momento',
    LIVENESS_ACTION_LOOK_DOWN_TITLE: 'Girar la cabeza ligeramente hacia abajo',
    LIVENESS_ACTION_LOOK_DOWN_TEXT:
        'Mantener los ojos en la pantalla en todo momento',
    LIVENESS_ACTION_SMILE_TITLE: 'Sonreír',
    LIVENESS_ACTION_SMILE_TEXT:
        'Mantener los ojos en la pantalla en todo momento',
    LIVENESS_ACTION_FROWN_TITLE: 'Fruncir el ceño',
    LIVENESS_ACTION_FROWN_TEXT:
        'Mantén la vista en la pantalla en todo momento',
    PASSIVE_LIVENESS_ERROR_FACE_TOO_CLOSE_TITLE:
        'Uh Oh... Estás demasiado cerca.',
    PASSIVE_LIVENESS_ERROR_FACE_CLOSE_TO_BORDER_TITLE:
        'Estás demasiado cerca, aléjate para que tu rostro quepa en el marco proporcionado. Vuelve a intentarlo.',
    PASSIVE_LIVENESS_ERROR_FACE_CROPPED_TITLE:
        'Algo salió mal. Vuelve a intentarlo.',
    PASSIVE_LIVENESS_ERROR_FACE_CROPPED: 'Algo salió mal. Vuelve a intentarlo.',
    PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND_TITLE:
        'No podemos detectar un rostro dentro de la imagen. Vuelve a intentarlo.',
    PASSIVE_LIVENESS_ERROR_FACE_TOO_SMALL_TITLE:
        'Estás demasiado lejos, acércate a la cámara y asegúrate de que tu rostro quepa en el marco. Vuelve a intentarlo.',
    PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE_TITLE:
        'Uh Oh... Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE:
        'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_TOO_MANY_FACES:
        'No podemos detectar un rostro en la imagen. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_FACE_IS_OCCLUDED_TITLE:
        'Parece que tu rostro está parcialmente cubierto, asegúrate de que todo tu rostro esté a la vista. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_UNKNOWN_TITLE: 'Uh Oh... Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_UNKNOWN: 'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_TITLE: 'Uh Oh... Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_INTERNAL: 'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD_TITLE:
        'Uh Oh... Algo salió mal. Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD:
        'Inténtalo de nuevo.\nUh Oh... Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_None_TITLE: 'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_None: 'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_FailedExpressions_TITLE: 'Uh Oh... Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_FailedExpressions:
        'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_IMAGE_TITLE:
        'Uh Oh... Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_IMAGE_ERROR_TITLE: 'Uh oh...Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_IMAGE_ERROR: 'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR_TITLE: 'Uh oh...Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR:
        'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE_TITLE:
        'Uh oh...Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE:
        'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL_TITLE:
        'Uh oh...Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL:
        'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE_TITLE: 'Uh oh...Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE:
        'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_INVALID_CONFIG_TITLE: 'Uh oh...Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_INVALID_CONFIG:
        'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD_TITLE:
        'Uh oh...Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD:
        'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT_TITLE:
        'Uh oh...Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT:
        'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT_TITLE:
        'Uh oh...Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT:
        'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS_TITLE:
        'Uh oh...Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS:
        'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE_TITLE: 'Uh oh...Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE:
        'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_NULLPTR_TITLE: 'Uh oh...Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_NULLPTR: 'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_LICENSE_ERROR_TITLE: 'Uh oh...Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_LICENSE_ERROR: 'Algo salió mal. Inténtalo de nuevo.',
    PASSIVE_LIVENESS_ERROR_INVALID_META_TITLE: 'Uh oh...Algo salió mal.',
    PASSIVE_LIVENESS_ERROR_INVALID_META: 'Algo salió mal. Inténtalo de nuevo.',
    INITIALIZING_TITLE: 'Inicializando',
    INITIALIZING_DESCRIPTION:
        'Comprobando capacidades de hardware, por favor espere...',
    JOURNEY_STATE_STARTED: 'Comenzó',
    JOURNEY_STATE_INPROGRESS: 'En progreso',
    JOURNEY_STATE_ENDED: 'Terminado',
    INFO_JOURNEY_STATE: 'Estado',
    INFO_JOURNEY_ACTION: 'Acción',
    INFO_JOURNEY_ACTION_ATTEMPT: 'Intento de Acción',
    INFO_JOURNEY_ID: 'ID de viaje',
    INFO_JOURNEY_RESULT: 'Resultado',
    RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE: 'Mensaje de resultado',
    RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE_VALUE:
        'La identificación que nos proporcionó no está actualizada. Pruebe con otra cosa.',
    INFO_JOURNEY_REFERENCE: 'Referencia',
    FLOW_STATE_NONE: 'Ninguno',
    'FLOW_STATE_IDENTITY:FRONT': 'Lado delantero',
    'FLOW_STATE_IDENTITY:BACK': 'Parte trasera',
    FLOW_STATE_ADDRESS: 'Dirección',
    FLOW_STATE_SELFIE: 'Autorretrato',
    FLOW_STATE_LIVENESS: 'Vivacidad',
    FLOW_STATE_COVID: 'Covid',
    PROVIDER_TITLE_CAMERA: 'Cámara',
    PROVIDER_TITLE_CROPPER: 'Cosechadora',
    PROVIDER_TITLE_FILESYSTEM_ID: 'Sube una foto de tu Documento de Identidad',
    PROVIDER_TITLE_FILESYSTEM_FACEMATCH: 'Sube una foto tuya',
    PROVIDER_TITLE_FILESYSTEM_ADDRESS:
        'Sube una foto de tu Comprobante de Domicilio',
    PROVIDER_TITLE_FILESYSTEM_COVID: 'Sube una foto de tu Documento Covid',
    PROVIDER_TITLE_GATEWAY: 'Puerta de enlace',
    PROVIDER_TITLE_LIVENESS: 'Vivacidad',
    PROVIDER_TITLE_LOGIN: 'Iniciar sesión',
    PROVIDER_TITLE_RESULTS: 'Resultados',
    PROVIDER_TITLE_SCANNER: 'Escanee su Documento de Identidad',
    PROVIDER_TITLE_VIEW_ID:
        'Verifique la vista previa de su Documento de Identidad',
    PROVIDER_TITLE_VIEW_FACEMATCH: 'Verifique la vista previa de su selfie',
    PROVIDER_TITLE_VIEW_ADDRESS:
        'Verifique la vista previa de su Comprobante de Domicilio',
    ROVIDER_TITLE_VIEW_COVID: 'Verifique la vista previa de su Covid',
    PROVIDER_SUBTITLE_FILESYSTEM_ID:
        'Suba una foto de su Documento de Identidad que esté clara, enfocada, no cubierta y de frente.',
    PROVIDER_SUBTITLE_FILESYSTEM_FACEMATCH:
        'Suba una foto suya que esté clara, enfocada, no cubierta y de frente',
    PROVIDER_SUBTITLE_FILESYSTEM_ADDRESS:
        'Suba una foto de su documento que esté clara, enfocada, no cubierta y de frente.',
    PROVIDER_SUBTITLE_FILESYSTEM_COVID:
        'Suba una foto de su documento que esté clara, enfocada, no cubierta y de frente.',
    PROVIDER_SUBTITLE_SCANNER_ID:
        'Coloque la página de la foto de su Documento de Identidad boca abajo en el escáner.',
    PROVIDER_SUBTITLE_VIEW_ID:
        'Verifique que la vista previa de su documento esté clara, enfocada, no cubierta y de frente.',
    PROVIDER_SUBTITLE_VIEW_FACEMATCH:
        'Verifique que la vista previa de su selfie esté clara, enfocada, no cubierta y de frente.',
    PROVIDER_SUBTITLE_VIEW_ADDRESS:
        'Verifique que la vista previa de su documento esté clara, enfocada, no cubierta y de frente.',
    PROVIDER_SUBTITLE_VIEW_COVID:
        'Verifique que la vista previa de su documento esté clara, enfocada, no cubierta y de frente.',
    PROVIDER_TITLE_SMART_CAPTURE: 'Captura inteligente',
    PROVIDER_TITLE_JOURNEY_SELECT: 'Viaje Seleccionado',
    PROVIDER_TITLE_TERMS_AND_CONDITIONS: 'Términos y condiciones',
    PROVIDER_TITLE_USER_INPUT: 'Complete el siguiente formulario',
    FILESYSTEM_SUPPORTED_TYPES_FIRST: 'Formatos aceptados:',
    FILESYSTEM_SUPPORTED_TYPES_LIST: 'JPG, PNG',
    FILESYSTEM_SUPPORTED_TYPES_START_SELFIE: 'Formatos aceptados: JPG, PNG',
    FILESYSTEM_MAX_FILE_SIZE:
        'Tamaño del archivo: aceptamos archivos de cualquier tamaño inferior a',
    FILESYSTEM_MAX_FILE_SIZE_NUMBER: '7,5 MB',
    FILESYSTEM_CHECK_FILE_TOO_BIG:
        'Su archivo es demasiado grande. Cargue un archivo de un tamaño inferior a 7,5 MB.',
    FILESYSTEM_CHECK_FILE_INCORRECT_FORMAT:
        'Su archivo tiene un formato incorrecto. Cargue uno de los formatos aceptados.',
    FILESYSTEM_IDENTITY_DOCUMENT: 'Documento de identidad',
    FILESYSTEM_FACEMATCH: 'Comparación de rostros',
    FILESYSTEM_ADDRESS: 'Comprobante de domicilio',
    FILESYSTEM_COVID: 'Covid',
    FILESYSTEM_DRAG_DROP: 'Arrastrar y soltar',
    FILESYSTEM_OR: 'o',
    FILESYSTEM_CHOOSE: 'Elegir un archivo',
    FILESYSTEM_UPLOADING: 'Subiendo...',
    TRIPLESCAN_GUIDANCE_TRYAGAIN: 'Inténtalo de nuevo',
    FAILURE_REASON_REFER: 'Su documento de identidad no superó la validación.',
    FAILURE_REASON_EXPIRED: 'Su documento de identidad ha caducado.',
    FAILURE_REASON_NOT_ACCEPTED:
        'Su documento de identidad no es un tipo de documento aceptado.',
    FAILURE_REASON_NOT_SUPPORTED:
        'Su documento de identidad no se pudo clasificar o no es compatible.',
    PLEASE_TRY_AGAIN_REFER: 'Inténtelo de nuevo.',
    PLEASE_TRY_AGAIN_EXPIRED: 'Inténtelo de nuevo con un documento válido.',
    PLEASE_TRY_AGAIN_NOT_ACCEPTED:
        'Inténtelo de nuevo con un documento diferente.',
    PLEASE_TRY_AGAIN_NOT_SUPPORTED: 'Inténtelo de nuevo.',
    BLUR_CHECK_REASON: 'Borroso: el documento no está claro;',
    GLARE_CHECK_REASON:
        'Deslumbrante: el documento es ilegible debido a una fuente de luz brillante;',
    RESOLUTION_CHECK_REASON:
        'Baja resolución: el documento no llena el marco correctamente;',
    EDGES_CHECK_REASON:
        'Bordes faltantes: el documento no está ubicado correctamente en el marco;',
    VALIDATION_FAILED: 'Validación fallida',
    VALIDATION_FAILED_REASON_DOC_UNKNOWN: '- documento desconocido.',
    VALIDATION_FAILED_REASON_DOC_NOT_ACCEPTED: '- documento no aceptado.',
    VALIDATION_FAILED_REASON_DOC_EXPIRED: '- documento vencido.',
    PREVIEW_INFO_TITLE_ID: 'Ejemplos de fotos buenas y malas',
    PREVIEW_INFO_GOOD: 'Buena',
    PREVIEW_INFO_BAD: 'Mala',
    PREVIEW_INFO_GOOD_EXAMPLE_ID:
        'La foto es clara, está enfocada y de frente.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID:
        'La foto debe mostrar las cuatro esquinas.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_ID: 'El documento no debe estar cubierto.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID: 'La foto no debe estar borrosa.',
    PREVIEW_INFO_TITLE_FACEMATCH: 'Consejos para una selfie de buena calidad',
    PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH:
        'La selfie es clara, está enfocada y de frente.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH:
        'La selfie debe mostrar el rostro completo.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH:
        'El rostro no debe estar cubierto.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH: 'La selfie no debe estar borrosa.',
    PREVIEW_INFO_TITLE_ADDRESS: 'Consejos para una foto de buena calidad',
    PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS:
        'La foto debe ser nítida, estar enfocada y mostrar el rostro directamente.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS:
        'La foto debe mostrar las cuatro esquinas.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS:
        'El documento no debe estar cubierto.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS: 'La foto no debe estar borrosa.',
    PREVIEW_INFO_TITLE_COVID: 'Consejos para una foto de buena calidad',
    PREVIEW_INFO_GOOD_EXAMPLE_COVID:
        'La foto debe ser nítida, estar enfocada y mostrar el rostro directamente.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID:
        'La foto debe mostrar las cuatro esquinas.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID:
        'El documento no debe estar cubierto.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID: 'La foto no debe estar borrosa.',
    ATTEMPTS_REMAINING: 'Número de intentos restantes:',
    CAMERA_CAPTURE: 'Encienda la cámara',
    CAMERA_CAPTURE_START_BUTTON: 'Inicie captura automática',
    CAMERA_CAPTURE_CAPTION:
        'Haga clic en Iniciar captura automática para comenzar',
    CAMERA_PREVIEW_START:
        'Encienda la cámara para iniciar la captura automática',
    CAMERA_CONDITION_BLUR: 'Desenfoque detectado',
    CAMERA_CONDITION_CAPTURING: 'Capturando',
    CAMERA_CONDITION_UPLOADING: 'Cargando... Por favor espere',
    CAMERA_CONDITION_ALIGNMENT: 'El documento no está enmarcado',
    CAMERA_CONDITION_GLARE: 'Reflejo detectado',
    VERIFYING_TITLE: 'Verificando...',
    PREPARING_PREVIEW_TITLE: 'Preparando vista previa...',
    CAMERA_CONDITION_LOW_RESOLUTION: 'Documento demasiado lejos',
    CAMERA_LOADING: 'Abriendo cámara...',
    CAMERA_SMARTCAPTURE_ON: 'CAPTURA AUTOMÁTICA - ACTIVADA',
    CAMERA_SMARTCAPTURE_OFF: 'CAPTURA AUTOMÁTICA - DESACTIVADA',
    CAMERA_CAPTURE_FRONT:
        'Coloca el lado con la foto de tu documento de identidad dentro del marco inferior.',
    CAMERA_MANUAL_CAPTURE_FRONT:
        'Coloca tu documento de identidad dentro del marco y haz clic en el botón de abajo',
    CAMERA_CAPTURE_BACK:
        'Coloca la parte de atrás de tu documento de identidad dentro del marco',
    CAMERA_CAPTURE_SELFIE_CAPTION:
        'Coloca tu rostro dentro del óvalo, mira directamente a la cámara y haz clic en el botón de abajo para tomar una selfie.',
    CAMERA_CAPTURE_ADDRESS_CAPTION:
        'Coloca tu comprobante de domicilio dentro del marco y haz clic en el botón de abajo para tomar una foto.',
    CAMERA_CAPTURE_COVID_CAPTION:
        'Coloca tu documento de Covid dentro del marco y haz clic en el botón de abajo para tomar una foto.',
    CAMERA_PREVENT_GLARE_HINT: 'Aleja el documento de fuentes de luz directa.',
    CAMERA_PREVENT_BLUR_HINT:
        'Sujete el documento o el dispositivo con firmeza.',
    CAMERA_PREVENT_LOW_RES_HINT:
        'Encaje el documento por completo dentro del marco.',
    CROPPER_RETRY: 'Reintentar',
    CROPPER_UPLOAD: 'Cargar',
    CROPPER_UPLOADING: 'Cargando...',
    FILESYSTEM_SELECT: 'Seleccionar',
    FILESYSTEM_DROP_IMAGE: 'o soltar imagen',
    GATEWAY_CAMERA: 'Cámara habilitada',
    GATEWAY_CANCEL: 'Cancelar viaje',
    LIVENESS_START: 'Iniciar Liveness',
    PASSIVE_LIVENESS_START: 'Tomar fotografía',
    LOGIN_USERNAME: 'Nombre de usuario',
    LOGIN_PASSWORD: 'Contraseña',
    LOGIN_SUBMIT: 'Enviar',
    RESULTS_DOCUMENTS: 'Documentos',
    RESULTS_DOCUMENTS_NONE: 'No se encontró ninguno',
    RESULTS_DOCUMENT_TYPE: 'Tipo de documento',
    RESULTS_DOCUMENT_RESULT: 'Resultado del documento',
    RESULTS_EXTRACTED_FIELDS_NONE: 'Detalles del resultado',
    RESULTS_DETAILS_NONE: 'No se encontró ninguno',
    RESULTS_NEW_JOURNEY: 'Comenzar Nuevo Viaje',
    RESULTS_NO_INFORMATION: 'No hay información para este viaje.',
    RESULTS_LOGOUT: 'Cerrar sesión',
    RESULTS_HIGH_LEVEL_Aborted: 'Abortado',
    RESULTS_HIGH_LEVEL_TCCDISAGREE: 'T&C abortado',
    RESULTS_HIGH_LEVEL_Expired: 'Caducado',
    RESULTS_HIGH_LEVEL_NotAccepted: 'No aceptado.',
    RESULTS_HIGH_LEVEL_NotSupported: 'No compatible',
    RESULTS_HIGH_LEVEL_Notsupported: 'No compatible',
    RESULTS_HIGH_LEVEL_Passed: 'Aprobado',
    RESULTS_HIGH_LEVEL_Refer: 'Referir',
    RESULTS_HIGH_LEVEL_Undefined: 'Indefinido',
    RESULTS_HIGH_LEVEL_DETAIL_ACCUMULATIVELIVENESSRESULT:
        'Resultado de Vida Acumulativa',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTFRONTSIDETYPECHECK:
        'Verificación del Tipo de Documento Lado Frontal',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBACKSIDECHECK:
        'Reverso del Documento de Verificación',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBLOCKINGPOLICY:
        'Política de Bloqueo de Documentos',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTEXPIRY:
        'Fecha de caducidad del documento',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTSUPPORT: 'Soporte de Documentos',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTVALIDATION: 'Validación de documentos',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTPROOFPOLICY:
        'Política de Prueba de Documentos',
    RESULTS_HIGH_LEVEL_DETAIL_FACEMATCHVALIDATION: 'Validación de Facematch',
    RESULTS_HIGH_LEVEL_DETAIL_UNDERAGERULE: 'Regla de menores',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_SUCCESS_NEEDED: 'Éxito necesario',
    RESULTS_HIGH_LEVEL_DETAIL_COVID_PASS_CROSSCHECK:
        'Comprobación de la compatibilidad del pasaporte Covid',
    RESULTS_HIGH_LEVEL_DETAIL_DATA_CHECK: 'Comprobación de datos',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_FAILED: 'Fracasado',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_NOTNEEDED: 'No necesario',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_PASSED: 'Aprobado',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_SKIPPED: 'Omitido',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_UNDETERMINED: 'Indeterminado',
    ADDITIONAL_CHECKS_DETAILS: 'Comprobaciones adicionales',
    ADDITIONAL_CHECKS_DETAILS_NONE: 'No se ha encontrado ninguno',
    ADDITIONAL_CHECKS_DETAIL_DATACHECKS: 'Comprobación de datos',
    ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK: 'Comprobaciones retrospectivas',
    ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK_NA: 'N/A',
    GBG_SCORES: 'Puntuación GBG',
    GBG_TRUST_SCORE: 'Puntuación GBG Trust',
    GBG_SCORE: 'Puntuación GBG',
    PREVIEW_TITLE: '¿Está clara la foto de su documento?',
    VIEW_RETRY: 'TOMAR FOTO DE NUEVO',
    VIEW_RETRY_DESKTOP: 'Cambiar foto',
    VIEW_CROP: 'Cosecha',
    VIEW_CROPPING: 'Recorte...',
    VIEW_UPLOAD: 'Subir',
    VIEW_UPLOAD_PREVIEW: 'SÍ, CONTINUAR',
    VIEW_UPLOADING: 'Subiendo...',
    SMART_CAPTURE_INITIALIZING: 'Comienzo',
    SMART_CAPTURE_START: 'Inicializando Smart Capture, Por favor espere...',
    SCANNER_DESC_AVAILABLE:
        'El escáner está disponible. Coloque su documento en el escáner.',
    SCANNER_DESC_PROCESSING: 'La imagen está siendo procesada por el servidor.',
    SCANNER_DESC_SCANNING:
        'La imagen está siendo escaneada por el dispositivo.',
    SCANNER_DESC_DISCONNECTED: 'El escáner está desconectado de la red.',
    SCANNER_DESC_NOT_CONNECTED: 'El escáner no está conectado.',
    SCANNER_DESC_OFFLINE: 'El escáner está fuera de línea.',
    SCANNER_DESC_BUSY:
        'El escáner está siendo utilizado por otro usuario en tu red local.',
    SCANNER_DESC_WAITING: 'Esperando a que se establezca la conexión.',
    SCANNER_DESC_LOADING: 'Por favor, espere...',
    SCANNER_TITLE_SCANNING: 'Escaneo...',
    SCANNER_TITLE_DISCONNECTED: 'DESCONECTADO',
    SCANNER_TITLE_NOT_CONNECTED: 'NO CONECTADO',
    SCANNER_TITLE_OFFLINE: 'Escáner desconectado',
    SCANNER_TITLE_BUSY: 'Escáner ocupado',
    SCANNER_TITLE_WAITING: 'ESPERANDO',
    SCANNER_ACTION_REGISTER: 'Registrar',
    SCANNER_ACTION_RELEASE: 'Lanzamiento',
    CANCEL_JOURNEY: 'Annullamento',
    MANUAL_PHOTO_UPLOAD_TOGGLE_FALSE: 'Carica una foto invece',
    MANUAL_PHOTO_UPLOAD_TOGGLE_TRUE: 'Scatta invece una foto',
    JOURNEY_SELECT_CONTINUE: 'Continua',
    HELP_MODAL_AUTOCAPTURE_TITLE:
        "Come scattare una foto del documento d'identità",
    HELP_MODAL_AUTOCAPTURE_SUBTITLE:
        "Quando l'acquisizione automatica è attiva, la schermata di acquisizione scatterà automaticamente una foto del documento quando avrà riconosciuto che la qualità è sufficiente.",
    HELP_MODAL_AUTOCAPTURE_TIPS:
        'Suggerimenti per scattare una foto di buona qualità',
    HELP_MODAL_AUTOCAPTURE_GLARE_TITLE:
        'Allontanare il documento dalle fonti di luce diretta.',
    HELP_MODAL_AUTOCAPTURE_FAR_TITLE: 'Documento troppo lontano',
    AUTOCAPTURE_FAR_SUBTITLE:
        "Inserire il documento completamente all'interno dell'inquadratura.",
    AUTOCAPTURE_BLUR_TITLE: 'Prevenire la sfocatura',
    HELP_MODAL_AUTOCAPTURE_BLUR_SUBTITLE:
        'Tenere fermo il documento o il dispositivo.',
    HELP_MODAL_AUTOCAPTURE_MANUAL_CAPTURE:
        "Ancora in difficoltà? Scattate una foto con l'Acquisizione manuale",
    HELP_MODAL_AUTOCAPTURE_TURN_MANUAL_CAPTURE: 'Cattura manuale',
    HELP_MODAL_SELFIE_TITLE: 'Come scattare un selfie',
    HELP_MODAL_SELFIE_SUBTITLE:
        'Guardare direttamente nella fotocamera e fare clic sul pulsante di cattura manuale.',
    HELP_MODAL_POA_TITLE:
        "Come scattare una foto della vostra prova d'indirizzo",
    HELP_MODAL_POA_SUBTITLE:
        "Posizionare il documento all'interno dell'inquadratura e fare clic sul pulsante di acquisizione per scattare una foto del documento.",
    HELP_MODAL_POA_TIPS: 'Consigli per scattare una foto di buona qualità',
    HELP_MODAL_POA_GLARE_TITLE: 'Evitare i riflessi',
    HELP_MODAL_POA_GLARE_SUBTITLE:
        'Allontanare il documento dalle fonti di luce diretta.',
    HELP_MODAL_POA_FAR_TITLE: 'Documento troppo lontano',
    HELP_MODAL_POA_FAR_SUBTITLE:
        'Inserire completamente il documento nella cornice.',
    HELP_MODAL_POA_BLUR_TITLE: 'Prevenire la sfocatura',
    HELP_MODAL_POA_BLUR_SUBTITLE: 'Tenere fermo il documento o il dispositivo.',
    HELP_MODAL_POA_MANUAL_CAPTURE:
        'Ancora difficoltà? Attivate la cattura manuale',
    HELP_MODAL_POA_TURN_MANUAL_CAPTURE: 'Acquisizione manuale',
    HELP_MODAL_COVID_TITLE: 'Come scattare una foto del documento Covid',
    HELP_MODAL_COVID_SUBTITLE:
        "Posizionare il documento all'interno della cornice e fare clic sul pulsante di acquisizione per scattare una foto del documento.",
    HELP_MODAL_COVID_TIPS:
        'Suggerimenti per scattare una foto di buona qualità',
    HELP_MODAL_COVID_GLARE_TITLE: 'Evitare i riflessi',
    HELP_MODAL_COVID_GLARE_SUBTITLE:
        'Allontanare il documento dalle fonti di luce diretta.',
    HELP_MODAL_COVID_FAR_TITLE: 'Documento troppo lontano',
    HELP_MODAL_COVID_FAR_SUBTITLE:
        "Inserire completamente il documento all'interno della cornice.",
    HELP_MODAL_COVID_BLUR_TITLE: 'Prevenire la sfocatura',
    HELP_MODAL_COVID_BLUR_SUBTITLE:
        'Tenere fermo il documento o il dispositivo.',
    HELP_MODAL_COVID_MANUAL_CAPTURE:
        'Ancora difficoltà? Attivate la cattura manuale',
    HELP_MODAL_COVID_TURN_MANUAL_CAPTURE: 'Cattura manuale',
    HELP_MODAL_NEED_HELP: 'Ayuda y opciones',
    EXCEPTION: "Si è verificata un'eccezione imprevista",
    EXCEPTION_AUTHORIZATION: 'Non autorizzato',
    EXCEPTION_AUTHORIZATION_ACCOUNT_NOT_AUTHORIZED:
        'Il vostro account non è autorizzato ad accedere a questa risorsa',
    EXCEPTION_AUTHORIZATION_AUTH_DETAILS_INVALID:
        'La combinazione di nome utente e password non è valida',
    EXCEPTION_AUTHORIZATION_AUTH_NOT_ENABLED:
        "È necessario abilitare l'autenticazione per utilizzare questa funzionalità",
    EXCEPTION_AUTHORIZATION_PROCESS_NOT_AUTHORIZED:
        'Non si è autorizzati per questo processo',
    EXCEPTION_BAD_REQUEST: 'Richiesta errata con codice di stato 400',
    EXCEPTION_BAD_REQUEST_INVALID_IMAGE: 'Immagine non valida',
    EXCEPTION_BAD_REQUEST_WAITING_FOR_RESPONSE:
        'Il viaggio è in attesa di una risposta',
    EXCEPTION_FLOW_STATE_JOURNEY_ENDED:
        'Non è possibile inviare richieste. Il viaggio è terminato',
    EXCEPTION_FLOW_STATE_MISSING: 'Stato del flusso non trovato',
    EXCEPTION_INVALID_PARAMETER_CALLBACK_MUST_BE_FUNCTION:
        'La devolución de llamada debe ser una función válida.',
    EXCEPTION_INVALID_PARAMETER_NAME_MUST_BE_STRING:
        'El nombre del evento debe ser un valor de cadena.',
    EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_NUMBER:
        'La prioridad debe ser un número.',
    EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_POSITIVE_NUMBER:
        'La prioridad debe ser un número positivo.',
    EXCEPTION_INVALID_PARAMETER_SHOULD_BE_ELEMENT_OR_SELECTOR:
        'El contenedor debe ser un elemento o un selector.',
    EXCEPTION_INVALID_PARAMETER_VALUE_NOT_VALID: 'El valor no es válido.',
    EXCEPTION_INVALID_PARAMETER_VALUE_DAMAGED: 'El valor ha sido dañado.',
    EXCEPTION_MISSING_PARAMETER_BACKEND_URL_MISSING:
        'La configuración debe incluir un parámetro backendUrl.',
    EXCEPTION_MISSING_PARAMETER_COORDINATES_MISSING:
        'Los parámetros suministrados deben contener coordenadas.',
    EXCEPTION_MISSING_PARAMETER_IMAGES_MISSING:
        'Los parámetros suministrados deben contener imágenes.',
    EXCEPTION_MISSING_PARAMETER_PASSWORD_MISSING:
        'Los parámetros suministrados deben contener la contraseña.',
    EXCEPTION_MISSING_PARAMETER_USERNAME_MISSING:
        'Los parámetros suministrados deben contener el nombre de usuario.',
    EXCEPTION_MISSING_REQUIRED_FIELD_MISSING:
        'Rellene todos los campos obligatorios',
    EXCEPTION_POSTCODE_FORMAT_ERROR:
        'El formato del código postal no es válido minLength:5 / maxLength:8',
    EXCEPTION_HOUSENUMBER_FORMAT_ERROR:
        'El formato Nombre/Número de la casa no es válido mínLongitud:1 / máxLongitud:20',
    EXCEPTION_STREETNAME_FORMAT_ERROR:
        'El nombre de la calle no es válido Longitud mínima:1 / Longitud máxima:30',
    EXCEPTION_TOWN_FORMAT_ERROR:
        'El formato de la ciudad no es válido mínLongitud:1 / máxLongitud:20',
    EXCEPTION_JOURNEY_DEFINITIONS_MISSING:
        'No hay definiciones de trayecto disponibles para este canal',
    EXCEPTION_NETWORK:
        'Se ha producido una excepción de red, por favor compruebe su conexión e inténtelo de nuevo',
    EXCEPTION_PLATFORM_BROWSER_ONLY:
        'Esta función sólo puede utilizarse en el navegador',
    EXCEPTION_PLATFORM_UNSUPPORTED: 'Su entorno no admite esta función',
    EXCEPTION_PLATFORM_CAMERA_PERMISSION_DENIED:
        'No se han concedido permisos a la cámara, compruebe la configuración del navegador.',
    EXCEPTION_PLATFORM_CAMERA_PERMISSION_UNAVAILABLE: '',
    EXCEPTION_PLATFORM_CAMERA_NOT_READABLE:
        'No se ha podido acceder a la cámara. Cierre cualquier otra aplicación e inténtelo de nuevo',
    EXCEPTION_PLATFORM_CAMERA_NONE_SUITABLE:
        'No se han encontrado cámaras adecuadas en su dispositivo',
    EXCEPTION_SERVER: 'Solicitud fallida con código de estado 500',
    EXCEPTION_SERVER_UNREACHABLE: 'Solicitud fallida, servidor inalcanzable',
    EXCEPTION_SERVER_DATA_NOT_PERSISTED:
        'Se ha producido un error durante el proceso. Es posible que no se conserven sus datos',
    EXCEPTION_SERVER_RESULT_NOT_PASSING: 'El resultado actual no pasa',
    EXCEPTION_TEMPLATE_CANVAS_CONTEXT_UNAVAILABLE:
        'El contexto del lienzo no está disponible',
    EXCEPTION_TEMPLATE_CONTAINER_MISSING: 'El contenedor no está presente',
    EXCEPTION_TEMPLATE_ELEMENTS_MISSING: 'Faltan elementos obligatorios',
    EXCEPTION_TEMPLATE_MISSING: 'Plantilla no encontrada',
    EXCEPTION_TEMPLATE_SOURCE_ELEMENT_MISSING:
        'No se puede encontrar el elemento fuente',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_CANNOT_RETRIEVE:
        'No se pueden obtener proveedores de entrada',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NONE_SPECIFIED:
        'No se han especificado proveedores de entrada',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NOT_AVAILABLE:
        'El proveedor de entrada no está disponible',
    'SUPPORTED_DOCUMENT_Account Statement': 'Estado de cuenta',
    'SUPPORTED_DOCUMENT_Agreement (Tenancy)': 'Acuerdo (Arrendamiento)',
    'SUPPORTED_DOCUMENT_Bank Document': 'Documento bancario',
    'SUPPORTED_DOCUMENT_Bank Letter': 'Carta bancaria',
    'SUPPORTED_DOCUMENT_Bank Statement': 'Estado de cuenta bancario',
    'SUPPORTED_DOCUMENT_Benefit Letter': 'Carta de beneficios',
    'SUPPORTED_DOCUMENT_Certificate (Birth, Marriage, Civil partnership)':
        'Certificado (de nacimiento, matrimonio, unión civil)',
    'SUPPORTED_DOCUMENT_Council Document': 'Documento del Consejo',
    'SUPPORTED_DOCUMENT_Council Letter': 'Carta del Consejo',
    'SUPPORTED_DOCUMENT_Council Tax': 'Impuesto municipal',
    'SUPPORTED_DOCUMENT_Driving License': 'Licencia de conducir',
    'SUPPORTED_DOCUMENT_Driving Licence': 'Licencia de conducir',
    'SUPPORTED_DOCUMENT_DWP Document': 'Documento DWP',
    'SUPPORTED_DOCUMENT_HMRC Document': 'Documento de HMRC',
    'SUPPORTED_DOCUMENT_Information Sheet': 'Hoja de información',
    'SUPPORTED_DOCUMENT_Insurance Document': 'Documento de seguro',
    'SUPPORTED_DOCUMENT_Insurance Letter': 'Carta de seguro',
    SUPPORTED_DOCUMENT_Invoice: 'Factura',
    'SUPPORTED_DOCUMENT_NIC Letter': 'Carta NIC',
    'SUPPORTED_DOCUMENT_NINO Letter': 'Carta NINO',
    'SUPPORTED_DOCUMENT_Official Document': 'Documento oficial',
    'SUPPORTED_DOCUMENT_Official Letter': 'Carta oficial',
    'SUPPORTED_DOCUMENT_Repayment Letter (related to Tax or Social support)':
        'Carta de pago (relacionada con impuestos o apoyo social)',
    'SUPPORTED_DOCUMENT_Tax Letter': 'Carta de impuestos',
    'SUPPORTED_DOCUMENT_Tax Statement': 'Declaración de impuestos',
    'SUPPORTED_DOCUMENT_Tel Bill': 'Factura de teléfono',
    'SUPPORTED_DOCUMENT_Tel Letter': 'Carta de Tel',
    'SUPPORTED_DOCUMENT_Telecommunication Document':
        'Documento de telecomunicaciones',
    'SUPPORTED_DOCUMENT_TV Licence': 'Licencia de televisión',
    'SUPPORTED_DOCUMENT_University Letter': 'Carta Universitaria',
    'SUPPORTED_DOCUMENT_Utility Bill': 'Factura de servicios.',
    'SUPPORTED_DOCUMENT_Utility Document': 'Documento de utilidad',
    'SUPPORTED_DOCUMENT_Utility Letter': 'Carta de Utilidad',
    'SUPPORTED_DOCUMENT_Water Bil': 'Agua Bil',
    'SUPPORTED_DOCUMENT_Water Document': 'Documento de Agua',
    'SUPPORTED_DOCUMENT_Agents License': 'Licencia de agentes',
    'SUPPORTED_DOCUMENT_Electoral Card': 'Tarjeta Electoral',
    'SUPPORTED_DOCUMENT_Foreigner Identification Card':
        'Tarjeta de Identificación de Extranjero',
    'SUPPORTED_DOCUMENT_Health Card': 'Tarjeta de Salud',
    'SUPPORTED_DOCUMENT_Job License': 'Licencia de trabajo',
    'SUPPORTED_DOCUMENT_Membership Identification Card':
        'Tarjeta de Identificación de Membresía',
    'SUPPORTED_DOCUMENT_Military Identification Card':
        'Tarjeta de Identificación Militar',
    'SUPPORTED_DOCUMENT_National Identification Card':
        'Documento de Identificación Nacional',
    SUPPORTED_DOCUMENT_Passport: 'Pasaporte',
    'SUPPORTED_DOCUMENT_Travel Permit': 'Permiso de viaje',
    SUPPORTED_DOCUMENT_Visa: 'Visa',
    'SUPPORTED_DOCUMENT_Weapons Licence': 'Licencia de armas',
    'SUPPORTED_DOCUMENT_Selfie Photo': 'Foto de selfie',
    SUPPORTED_DOCUMENT_Unknown: 'Desconocido',
    SUPPORTED_DOCUMENT_COVIDPAS: 'Pase Covid',
    EXTRACTED_FIELDS_AddressFull: 'Dirección completa',
    EXTRACTED_FIELDS_AddressCity: 'Dirección Ciudad',
    EXTRACTED_FIELDS_AddressPostCode: 'Código Postal de la Dirección',
    EXTRACTED_FIELDS_LastNameFirstPart: 'Apellido Primer Parte',
    EXTRACTED_FIELDS_Sex: 'Género',
    EXTRACTED_FIELDS_BirthPlace: 'Lugar de nacimiento',
    EXTRACTED_FIELDS_IssueNumber: 'Número de problema',
    EXTRACTED_FIELDS_DocumentNumberCheckDigit:
        'Dígito de Verificación del Número de Documento',
    EXTRACTED_FIELDS_BirthDate: 'Fecha de nacimiento',
    EXTRACTED_FIELDS_DocumentNumber: 'Número de documento',
    EXTRACTED_FIELDS_FirstName: 'Primer Nombre',
    EXTRACTED_FIELDS_ArbitraryDigit: 'Dígito arbitrario',
    EXTRACTED_FIELDS_FirstNameInitial: 'Inicial del primer nombre',
    EXTRACTED_FIELDS_ExpiryDate: 'Fecha de caducidad',
    EXTRACTED_FIELDS_IssueDate: 'Fecha de emisión',
    EXTRACTED_FIELDS_LastName: 'Apellido',
    EXTRACTED_FIELDS_LicenseCategory: 'Categoría de licencia',
    EXTRACTED_FIELDS_DocumentCategory: 'Categoría de documento',
    EXTRACTED_FIELDS_DocumentType: 'Tipo de documento',
    EXTRACTED_FIELDS_NationalityCode: 'Código de Nacionalidad',
    EXTRACTED_FIELDS_MiddleName: 'Segundo nombre',
    EXTRACTED_FIELDS_FirstIssuanceDate: 'Fecha de emisión inicial',
    EXTRACTED_FIELDS_SecondLastName: 'Segundo Apellido',
    EXTRACTED_FIELDS_FullName: 'Nombre completo',
    EXTRACTED_FIELDS_PersonalNumber: 'Número Personal',
    EXTRACTED_FIELDS_NationalityName: 'Nacionalidad',
    EXTRACTED_FIELDS_BarcodeItems: 'Código de barras',
    EXTRACTED_FIELDS_BirthPlaceCity: 'Ciudad de nacimiento',
    EXTRACTED_FIELDS_BirthPlaceState: 'Estado de nacimiento',
    EXTRACTED_FIELDS_BirthPlaceCountry: 'País de nacimiento',
    EXTRACTED_FIELDS_MRZFull: 'MRZ completo',
    EXTRACTED_FIELDS_MRZLine1: 'Línea MRZ 1',
    EXTRACTED_FIELDS_MRZLine2: 'Línea MRZ 2',
    EXTRACTED_FIELDS_MRZLine3: 'Línea MRZ 3',
    EXTRACTED_FIELDS_ObservationPage: 'Página de Observación',
    EXTRACTED_FIELDS_IssuingAuthority: 'Autoridad Emisora',
    EXTRACTED_FIELDS_IssuingLocation: 'Lugar de emisión',
    EXTRACTED_FIELDS_MaritalStatus: 'Estado civil',
    EXTRACTED_FIELDS_Occupation: 'Ocupación',
    EXTRACTED_FIELDS_AlienNumber: 'Número Alienígena',
    EXTRACTED_FIELDS_Employer: 'Empleador',
    EXTRACTED_FIELDS_AddressLine1: 'Línea de dirección 1',
    EXTRACTED_FIELDS_AddressLine2: 'Línea de dirección 2',
    EXTRACTED_FIELDS_AddressLine3: 'Línea de dirección 3',
    EXTRACTED_FIELDS_AddressLine4: 'Línea de dirección 4',
    EXTRACTED_FIELDS_AddressState: 'Estado',
    EXTRACTED_FIELDS_AddressDistrict: 'Distrito',
    EXTRACTED_FIELDS_AddressBuildingNumber: 'Número de edificio',
    EXTRACTED_FIELDS_AddressBuildingName: 'Nombre del edificio',
    EXTRACTED_FIELDS_AddressStreet: 'Calle',
    EXTRACTED_FIELDS_AddressCountry: 'País',
    EXTRACTED_FIELDS_RefAddressFull: 'Dirección de referencia',
    EXTRACTED_FIELDS_RefAddressLine1: 'Línea de dirección de referencia 1',
    EXTRACTED_FIELDS_RefAddressLine2: 'Línea de dirección de referencia 2',
    EXTRACTED_FIELDS_RefAddressLine3: 'Línea de dirección de referencia 3',
    EXTRACTED_FIELDS_RefAddressLine4: 'Línea de dirección de referencia 4',
    EXTRACTED_FIELDS_RefAddressCity: 'Dirección de referencia Ciudad',
    EXTRACTED_FIELDS_RefAddressState: 'Estado de la dirección de referencia',
    EXTRACTED_FIELDS_RefAddressDistrict: 'Dirección de referencia Distrito',
    EXTRACTED_FIELDS_RefAddressBuildingNumber:
        'Número de edificio de dirección de referencia',
    EXTRACTED_FIELDS_RefAddressBuildingName:
        'Nombre del edificio de la dirección de referencia',
    EXTRACTED_FIELDS_RefAddressSubBuildingName:
        'Nombre del Edificio de Subdirección de Dirección de Referencia',
    EXTRACTED_FIELDS_RefAddressStreet: 'Calle de la dirección de referencia',
    EXTRACTED_FIELDS_RefAddressCountry: 'Dirección de referencia País',
    EXTRACTED_FIELDS_RefAddressPostCode:
        'Dirección de referencia Código postal',
    EXTRACTED_FIELDS_HealthNumber: 'Número de salud',
    EXTRACTED_FIELDS_Endorsements: 'Recomendaciones',
    EXTRACTED_FIELDS_Constraints: 'Restricciones',
    EXTRACTED_FIELDS_LicenseMarine: 'Licencia Marina',
    EXTRACTED_FIELDS_Height: 'Altura',
    EXTRACTED_FIELDS_Weight: 'Peso',
    EXTRACTED_FIELDS_HairColor: 'Color de cabello',
    EXTRACTED_FIELDS_EyeColor: 'Color de ojos',
    EXTRACTED_FIELDS_LensData: 'Vista',
    EXTRACTED_FIELDS_SocialSecurityNumber: 'Número de Seguro Social',
    EXTRACTED_FIELDS_NationalInsuranceNumber: 'Número de Seguro Nacional',
    EXTRACTED_FIELDS_Race: 'Raza',
    EXTRACTED_FIELDS_MotherName: 'Nombre de la madre',
    EXTRACTED_FIELDS_FatherName: 'Nombre del padre',
    EXTRACTED_FIELDS_Parents: 'Padres',
    EXTRACTED_FIELDS_Remarks: 'Observaciones',
    EXTRACTED_FIELDS_DistinguishingMarks: 'Marcas Distintivas',
    EXTRACTED_FIELDS_PeriodOfStay: 'Período de estancia',
    EXTRACTED_FIELDS_TaxNumber: 'Número de impuestos',
    EXTRACTED_FIELDS_Donor: 'Donante',
    EXTRACTED_FIELDS_RFIDG1: 'Datos en bruto de RFID Grupo 1',
    EXTRACTED_FIELDS_RFIDG2: 'Datos en bruto de RFID Grupo 2',
    EXTRACTED_FIELDS_RFIDG3: 'Datos en bruto de RFID Grupo 3',
    EXTRACTED_FIELDS_RFIDG15: 'Datos en bruto de RFID Grupo 4',
    EXTRACTED_FIELDS_RFIDSOD: 'Datos en bruto de RFID Grupo 5',
    EXTRACTED_FIELDS_PortraitPhoto: 'Foto de retrato extraída',
    EXTRACTED_FIELDS_Title: 'Título',
    EXTRACTED_FIELDS_IssueDate2: 'Fecha de la segunda emisión',
    EXTRACTED_FIELDS_ExpiryDate2: 'Segunda Fecha de Caducidad',
    EXTRACTED_FIELDS_LicenseCategory2: 'Segunda Categoría de Licencia',
    EXTRACTED_FIELDS_IssueDate3: 'Tercera Fecha de Emisión',
    EXTRACTED_FIELDS_ExpiryDate3: 'Tercera Fecha de Vencimiento',
    EXTRACTED_FIELDS_LicenseCategory3: 'Tercera Categoría de Licencia',
    EXTRACTED_FIELDS_IssueDate4: 'Fecha de la cuarta edición',
    EXTRACTED_FIELDS_ExpiryDate4: 'Cuarta Fecha de Caducidad',
    EXTRACTED_FIELDS_LicenseCategory4: 'Cuarta Categoría de Licencia',
    EXTRACTED_FIELDS_MRZCode1: 'Código MRZ 1',
    EXTRACTED_FIELDS_MRZCode2: 'Código MRZ 2',
    EXTRACTED_FIELDS_MRZStandardType: 'Tipo Estándar MRZ',
    EXTRACTED_FIELDS_AddressStreetSuffix: 'Sufijo de calle',
    EXTRACTED_FIELDS_AddressStreetType: 'Tipo de calle',
    EXTRACTED_FIELDS_AddressUnitNumber: 'Número de unidad de dirección',
    EXTRACTED_FIELDS_LicenseNumber: 'Número de licencia',
    EXTRACTED_FIELDS_AddressStateCode: 'Código de Estado',
    EXTRACTED_FIELDS_AddressStreetTypeAbbreviation: 'Abreviatura de calle',
    EXTRACTED_FIELDS_AddressUnitType: 'Tipo de Unidad de Dirección',
    EXTRACTED_FIELDS_AddressDeliveryPointIdentifier:
        'Identificador de Punto de Entrega',
    EXTRACTED_FIELDS_AgeCategory: 'Categoría de edad',
    EXTRACTED_FIELDS_ChildernCount: 'Número de niños',
    EXTRACTED_FIELDS_EntryMode: 'Modo de entrada',
    EXTRACTED_FIELDS_VAFNumber: 'Número VAF',
    EXTRACTED_FIELDS_AddressLine5: 'Línea de dirección 5',
    EXTRACTED_FIELDS_RFIDPortraitPhoto: 'Foto de retrato de RFID',
    EXTRACTED_FIELDS_RefAddressLine5: 'Línea de dirección de referencia 5',
    EXTRACTED_FIELDS_RefAddressStateCode:
        'Estado de la dirección de referencia',
    EXTRACTED_FIELDS_RefAddressStreetType:
        'Tipo de calle de la dirección de referencia',
    EXTRACTED_FIELDS_RefAddressStreetTypeAbbreviation:
        'Abreviatura del Tipo de Calle de la Dirección de Referencia',
    EXTRACTED_FIELDS_RefAddressStreetSuffix:
        'Sufijo de la Calle de la Dirección de Referencia',
    EXTRACTED_FIELDS_RefAddressUnitNumber:
        'Número de Unidad de Dirección de Referencia',
    EXTRACTED_FIELDS_RefAddressUnitType:
        'Tipo de Unidad de Dirección de Referencia',
    EXTRACTED_FIELDS_RefAddressPostcodeType:
        'Dirección de referencia Código postal Tipo',
    EXTRACTED_FIELDS_RefAddressDeliveryPointIdentifier:
        'Identificador de Punto de Entrega de Dirección de Referencia',
    EXTRACTED_FIELDS_RefAddressPOBoxNumber:
        'Número de apartado postal de la dirección de referencia',
    EXTRACTED_FIELDS_RefAddressDependentLocality:
        'Localidad Dependiente de Dirección',
    EXTRACTED_FIELDS_RefAddressDoubleDependentLocality:
        'Domicilio de referencia Doble Localidad Dependiente',
    EXTRACTED_FIELDS_RefAddressThoroughfare:
        'Dirección de referencia de la vía',
    EXTRACTED_FIELDS_RefAddressThoroughfareDesc:
        'Descripción de la vía de la dirección de referencia',
    EXTRACTED_FIELDS_RefAddressDependentThoroughfare:
        'Vía Dependiente de Dirección de Referencia',
    EXTRACTED_FIELDS_RefAddressDependentThoroughfareDesc:
        'Descripción de la vía dependiente de la dirección de referencia',
    EXTRACTED_FIELDS_RefAddressSubBuildingNumber:
        'Número de edificio de la dirección de referencia.',
    EXTRACTED_FIELDS_AddressSubBuildingNumber: 'Número de Edificio Sub',
    EXTRACTED_FIELDS_AddressSubBuildingName: 'Nombre del Edificio',
    EXTRACTED_FIELDS_AddressPostCodeType: 'Tipo de código postal',
    EXTRACTED_FIELDS_IssuingAuthorityType: 'Tipo de Autoridad Emisora',
    EXTRACTED_FIELDS_Signature: 'Firma',
    EXTRACTED_FIELDS_Hologram: 'Holograma',
    EXTRACTED_FIELDS_CardNumber: 'Número de tarjeta',
    EXTRACTED_FIELDS_MiddleNameInitial: 'Inicial del segundo nombre',
    EXTRACTED_FIELDS_PermitNumber: 'Número de permiso',
    EXTRACTED_FIELDS_ReferenceNumber: 'Número de referencia',
    EXTRACTED_FIELDS_CustomerNumber: 'Número de cliente',
    EXTRACTED_FIELDS_BOSNumber: 'Número BOS',
    EXTRACTED_FIELDS_StudentID: 'Número de Identificación del Estudiante',
    EXTRACTED_FIELDS_MembershipNumber: 'Número de membresía',
    EXTRACTED_FIELDS_LicenseType: 'Tipo de licencia',
    EXTRACTED_FIELDS_LicenseType2: 'Tipo de licencia 2',
    EXTRACTED_FIELDS_LicenseType3: 'Tipo de licencia 3',
    EXTRACTED_FIELDS_LicenseType4: 'Tipo de licencia 4',
    EXTRACTED_FIELDS_DocumentTypeCode: 'Código de Tipo de Documento',
    EXTRACTED_FIELDS_MRZDocumentNumberCheckDigit: 'Dígito de Verificación MRZ',
    EXTRACTED_FIELDS_MRZBirthDateCheckDigit:
        'Dígito de verificación de la fecha de nacimiento MRZ',
    EXTRACTED_FIELDS_MRZExpiryDateCheckDigit:
        'Dígito de verificación de la fecha de vencimiento del MRZ',
    EXTRACTED_FIELDS_MRZPersonalNumberCheckDigit:
        'Dígito de Verificación del Número Personal MRZ',
    EXTRACTED_FIELDS_MRZCompositeCheckDigit:
        'Dígito de Verificación Compuesto MRZ',
    EXTRACTED_FIELDS_SecondaryPortraitPhoto: 'Foto de retrato secundario',
    EXTRACTED_FIELDS_Fingerprint: 'Huella dactilar',
    EXTRACTED_FIELDS_VersionNumber: 'Número de versión',
    EXTRACTED_FIELDS_Conditions: 'Condiciones',
    EXTRACTED_FIELDS_NickName: 'Apodo',
    EXTRACTED_FIELDS_AddressApartmentNumber: 'Número de apartamento',
    EXTRACTED_FIELDS_AddressFloorNumber: 'Número de piso',
    EXTRACTED_FIELDS_FirstNameLocal: 'Nombre Local',
    EXTRACTED_FIELDS_LastNameLocal: 'Apellido Local',
    EXTRACTED_FIELDS_FullNameLocal: 'Nombre completo local',
    EXTRACTED_FIELDS_BirthPlaceLocal: 'Lugar de nacimiento local',
    EXTRACTED_FIELDS_IssuingAuthorityLocal: 'Autoridad Emisora Local',
    EXTRACTED_FIELDS_MotherNameLocal: 'Nombre de la madre Local',
    EXTRACTED_FIELDS_FatherNameLocal: 'Nombre del Padre Local',
    EXTRACTED_FIELDS_AddressFullLocal: 'Dirección Completa Local',
    EXTRACTED_FIELDS_MiddleNameLocal: 'Segundo Nombre Local',
    EXTRACTED_FIELDS_AddressLine1Local: 'Línea de dirección 1 Local',
    EXTRACTED_FIELDS_AddressLine2Local: 'Línea de dirección 2 Local',
    EXTRACTED_FIELDS_AddressLine3Local: 'Línea de dirección 3 Local',
    EXTRACTED_FIELDS_IndRefNumber1: 'Número de Referencia Individual 1',
    EXTRACTED_FIELDS_IndRefNumber2: 'Número de Referencia Individual 2',
    EXTRACTED_FIELDS_IndRefNumber3: 'Número de Referencia Individual 3',
    EXTRACTED_FIELDS_IndRefNumber4: 'Número de Referencia Individual 4',
    EXTRACTED_FIELDS_IndRefNumber5: 'Número de Referencia Individual 5',
    EXTRACTED_FIELDS_Name1: 'Nombre 1',
    EXTRACTED_FIELDS_Name2: 'Nombre 2',
    EXTRACTED_FIELDS_Name3: 'Nombre 3',
    EXTRACTED_FIELDS_Name4: 'Nombre 4',
    EXTRACTED_FIELDS_Name5: 'Nombre 5',
    EXTRACTED_FIELDS_RECIPIENT_NAME_1: 'Nombre del destinatario 1',
    EXTRACTED_FIELDS_RECIPIENT_NAME_2: 'Nombre del destinatario 2',
    EXTRACTED_FIELDS_RECIPIENT_NAME_3: 'Nombre del destinatario 3',
    EXTRACTED_FIELDS_RECIPIENT_NAME_4: 'Nombre del destinatario 4',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_FULL: 'Dirección del destinatario',
    EXTRACTED_FIELDS_IBAN: 'Número de cuenta IBAN',
    EXTRACTED_FIELDS_ACCOUNT_NUM: 'Número de cuenta',
    EXTRACTED_FIELDS_ISSUER: 'Emisor',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_CITY:
        'Dirección del destinatario Ciudad',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_POST_CODE:
        'Dirección del destinatario Código postal',
    EXTRACTED_FIELDS_DAY: 'Día',
    EXTRACTED_FIELDS_MONTH: 'Mes',
    EXTRACTED_FIELDS_YEAR: 'Año',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_1: 'Valor opcional 1',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_2: 'Valor opcional 2',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_3: 'Valor opcional 3',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_4: 'Valor opcional 4',
    EXTRACTED_FIELDS_ISSUING_STATE_NAME: 'Nombre del Estado emisor',
    EXTRACTED_FIELDS_FRONT_DOCUMENT_TYPE_ID:
        'Id. de tipo de documento en el anverso',
    EXTRACTED_FIELDS_BACK_DOCUMENT_TYPE_ID:
        'Id. del tipo de documento en el reverso',
    HASNOCAMERA_TITLE: 'No hemos podido reconocer la cámara de su dispositivo.',
    HASNOCAMERA_DESCRIPTION:
        'parece que su dispositivo no tiene cámara, por favor, vuelva a intentarlo en un dispositivo diferente que tenga una cámara que funcione para que pueda llevar a cabo todos los pasos requeridos.',
    EXTRACTED_FIELDS_COVIDPASSCROSSCHECKRESULT: 'Covid Tipo Id',
    USER_INPUT_FIRST_NAME: 'Nombre de pila',
    USER_INPUT_MIDDLE_NAME: 'Segundo nombre',
    USER_INPUT_LAST_NAME: 'Apellidos',
    USER_INPUT_DOB: 'Fecha de nacimiento',
    USER_INPUT_HOUSE_NAME_NUMBER: 'Nombre y número de la casa',
    USER_INPUT_STREET_NAME: 'Nombre de la calle',
    USER_INPUT_TOWN: 'Ciudad*',
    USER_INPUT_POSTAL_CODE: 'Código postal',
    USER_INPUT_HOUSE_NAME_NUMBER_EXAMPLE: 'p.ej. Casa/35',
    USER_INPUT_STREET_NAME_EXAMPLE: 'p.ej. Calle Test',
    USER_INPUT_TOWN_EXAMPLE: 'p.ej. Somewhere',
    USER_INPUT_POSTAL_CODE_EXAMPLE: 'p.ej. CH496 (sin espacios)',
    SYSTEM_NOT_ABLE: 'El sistema no pudo escanear el documento',
    TRY_AGAIN: 'Inténtalo de nuevo',
    HINTS_DISABLED_HEADER: 'Las pistas están desactivadas en modo manual',
    HINTS_DISABLED_DESCRIPTION:
        'Si deseas activar las pistas para tomar una foto, cambia al modo CAPTURA AUTOMÁTICA',
    YOU_HAVE: 'Tienes',
    PICTURE_VERIFYING: 'Verificando...',
    HOW_TO_TAKE_PHOTO_CORRECTLY: 'Cómo tomar una foto correctamente',
};
